var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0002 2.30556C7.98279 2.30556 6.34739 3.94096 6.34739 5.95834C6.34739 7.97571 7.98279 9.61111 10.0002 9.61111C12.0175 9.61111 13.6529 7.97571 13.6529 5.95834C13.6529 3.94096 12.0175 2.30556 10.0002 2.30556ZM8.09739 5.95834C8.09739 4.90746 8.94929 4.05556 10.0002 4.05556C11.051 4.05556 11.9029 4.90746 11.9029 5.95834C11.9029 7.00921 11.051 7.86111 10.0002 7.86111C8.94929 7.86111 8.09739 7.00921 8.09739 5.95834Z",
    fill: "#1A1A1A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.88985 17.3711C2.88043 17.5478 3.02196 17.6944 3.1989 17.6944H4.3271C4.49392 17.6944 4.63141 17.5635 4.64296 17.3971C4.65855 17.1726 4.6842 16.8723 4.71939 16.6868C5.19106 14.1999 7.37598 12.3194 10.0001 12.3194C12.6242 12.3194 14.8091 14.1999 15.2808 16.6868C15.316 16.8723 15.3416 17.1726 15.3572 17.3971C15.3688 17.5635 15.5063 17.6944 15.6731 17.6944H16.8013C16.9782 17.6944 17.1198 17.5478 17.1103 17.3711C17.0986 17.1504 17.0798 16.8666 17.0544 16.6868C16.5649 13.229 13.5931 10.5694 10.0001 10.5694C6.40712 10.5694 3.43529 13.229 2.9458 16.6868C2.92035 16.8666 2.90162 17.1504 2.88985 17.3711Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.ef425cc3c231545baacd420e4ea68f5d.svg";
export { ForwardRef as ReactComponent };